var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-box"},[_c('img',{attrs:{"src":"/gpassist/img/loader.gif","alt":"loader","width":_vm.width}})])
}
var staticRenderFns = []

export { render, staticRenderFns }